//#region src/constants/grouping.ts
var e = 10, t = 1024, n = 7, r = 1e4, i = 10, a = 7, o = 100;
//#endregion
export { o as CHANNEL_GROUPING_LIMIT, a as CHANNEL_GROUPING_TERM_SIZE, n as CONTINENT_GROUPING_TERM_SIZE, t as COUNTRY_GROUPING_TERM_SIZE, e as GEO_GROUPING_LIMIT, i as TEAM_GROUPING_LIMIT, r as TEAM_GROUPING_TERM_SIZE };
